<template>
    <div>
        <q-table
            :data="evidences"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="requestEvidences"
            :loading="loading"
            selection="multiple"
            :selected.sync="files_selected"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            class="q-mt-md"
            binary-state-sort
            >

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="negative" icon="far fa-ban" :label="$t('remove')" @click="removeEvidences" class="q-mr-sm" v-if="files_selected.length > 0" :disable="disableEvidences" />
                <q-btn color="secondary" icon="far fa-plus" :label="$t('add_evidence')" @click="add_evidence = true" :disable="disableEvidences" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th auto-width>
                    <q-checkbox v-model="props.selected" indeterminate-value="some" :disable="disableEvidences" />
                </q-th>

                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props">
                <q-td auto-width>
                    <q-checkbox color="primary" v-model="props.selected" :disable="disableEvidences" />
                </q-td>

                <q-td key="description" :props="props">
                    {{ $truncateLink(props.row.description) }}
                </q-td>

                <q-td key="file_url" :props="props" class="file-url">
                    <a :href="props.row.file_url" target="_blank">{{ $truncateLink(props.row.file_url) }}</a>
                </q-td>

                <q-td key="extension" :props="props">
                    {{ props.row.extension }}
                </q-td>

                <q-td key="size" :props="props">
                    {{ props.row.size }}
                </q-td>

                <q-td auto-width key="actions" :props="props">
                    <q-btn round flat icon="fal fa-trash" color="negative" @click="removeEvidence(props)" :disable="disableEvidences" />
                </q-td>
            </q-tr>
        </q-table>

        <q-modal v-model="add_evidence" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-esc-dismiss no-backdrop-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="closeAddEvidence" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('evidences') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-xs">
                        <div class="col-12">
                            <q-input v-model="description" :float-label="$t('description')" :error="$v.description.$error" @input="$v.description.$touch" />
                        </div>

                        <div class="col-12">
                            <div class="row gutter-sm">
                                <div class="col-xs-12 col-sm-6">
                                    <p class="caption">{{ $t('file') }}</p>
                                    <uploader @fileUploaded="fileUploaded" :multiple="false" :cropper="false" :disable="disableEvidences" :error="$v.file_url.$error" />

                                    <p v-if="file_url" class="q-mt-md file-url">
                                        <q-icon name="fal fa-check" color="positive" />
                                        <a :href="file_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="closeAddEvidence" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveFile()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'

export default {
    name: 'AdminPresentialEvidences',

    props: ['status', 'is_training_manager'],

    data() {
        return {
            presential_event_id: '',
            evidences: [],
            columns: [
                {
                    name: 'description',
                    required: true,
                    label: 'description',
                    align: 'left',
                    field: 'description',
                    sortable: false,
                },
                {
                    name: 'file_url',
                    required: true,
                    label: 'file',
                    align: 'left',
                    field: 'file_url',
                    sortable: false,
                },
                {
                    name: 'extension',
                    required: true,
                    label: 'extension',
                    align: 'left',
                    field: 'extension',
                    sortable: false,
                },
                {
                    name: 'size',
                    required: true,
                    label: 'size',
                    align: 'left',
                    field: 'size',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'actions',
                    sortable: false,
                }
            ],
            server_pagination: {
                page: 1,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            loading: false,
            file_url: '',
            description: '',
            files_selected: [],
            add_evidence: false
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
		...mapGetters({
            access_token: 'common/access_token'
		}),

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        disableEvidences() {
            if (this.status === 8 && !this.is_training_manager) return true
            else return false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        requestEvidences({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": '',
                "ordering": order_by
            }

            this.$axios.get(`/presential/presential_events/${this.presential_event_id}/evidences/`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.evidences = response.data.results.map(e => {
                    return { ...e, actions: e.id, selected: false }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        saveFile() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    file_url: this.file_url,
                    description: this.description
                }

                this.$axios.post(`/presential/presential_events/${this.presential_event_id}/evidences/`, data, this.getHeader)
                .then(response => {
                    this.$q.notify({
                        message: this.$t('evidence_save_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })

                    this.requestEvidences({
                        pagination: {
                            page: 1,
                            rowsPerPage: 0,
                            descending: false,
                            sortBy: null
                        }
                    })

                    this.closeAddEvidence()
                })
                .catch(e => {
                    console.log(e)

                    this.$q.notify({
                        message: this.$t('evidence_save_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        },

        fileUploaded(url) {
            this.file_url = url
        },

        removeEvidence(props) {
            this.files_selected = []
            this.files_selected.push(props.row.id)

            this.saveRemoveEvidences()
        },

        removeEvidences() {
            this.files_selected = this.files_selected.map(e => e.id)
            this.saveRemoveEvidences()
        },

        saveRemoveEvidences() {
            this.$q.loading.show()

            let data = {
                file_url: this.files_selected.filter(e => !isNaN(e))
            }

            this.$axios.post(`/presential/presential_events/${this.presential_event_id}/evidences/delete_files/`, data, this.getHeader)
            .then(() => {
                this.requestEvidences({
                    pagination: {
                        page: 1,
                        rowsPerPage: 0,
                        descending: false,
                        sortBy: null
                    }
                })

                this.$q.notify({
                    message: this.$t('evidences_remove_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })

                this.files_selected = []
            })
            .catch(e => {
                console.log(e)

                this.$q.notify({
                    message: this.$t('evidences_remove_error'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        closeAddEvidence() {
            this.file_url = ''
            this.description = ''
            this.$v.$reset()
            this.add_evidence = false
        }
    },

    created() {
        this.presential_event_id = this.$route.params.id

        this.requestEvidences({
            pagination: this.server_pagination
        })
    },

    validations() {
        return {
            file_url: { required },
            description: { required }
        }
    }
}
</script>

<style>

</style>
